import { Box, BoxProps, SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import MuiImage from "mui-image";
import { LazyLoadImageProps } from "react-lazy-load-image-component";

// ----------------------------------------------------------------------

type IProps = BoxProps & LazyLoadImageProps;

interface Props extends IProps {
	sx?: SxProps<Theme>;
	fit?: "cover" | "contain";
}

export default function Image({ sx, fit = "cover", ...other }: Props) {
	return (
		<Box
			component='span'
			sx={{
				lineHeight: 0,
				display: "block",
				overflow: "hidden",
				"& .wrapper": {
					width: 1,
					height: 1,
					backgroundSize: "cover !important"
				},
				...sx
			}}
		>
			<Box
				component={MuiImage}
				duration={500}
				fit={fit}
				sx={{ width: 1, height: 1, objectFit: "cover" }}
				wrapperClassName='wrapper'
				{...other}
			/>
		</Box>
	);
}
